import { Component } from '@angular/core';

@Component({
  selector: 'app-no-pet',
  templateUrl: './no-pet.component.html',
  styleUrls: ['./no-pet.component.scss']
})
export class NoPetComponent {

}
